"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatform = exports.PlatformProvider = void 0;
var react_1 = __importStar(require("react"));
var CONSTANTS_1 = require("stremio/common/CONSTANTS");
var useShell_1 = __importDefault(require("./useShell"));
var device_1 = require("./device");
var PlatformContext = (0, react_1.createContext)({});
var PlatformProvider = function (_a) {
    var children = _a.children;
    var shell = (0, useShell_1.default)();
    var openExternal = function (url) {
        try {
            var hostname_1 = new URL(url).hostname;
            var isWhitelisted = CONSTANTS_1.WHITELISTED_HOSTS.some(function (host) { return hostname_1.endsWith(host); });
            var finalUrl = !isWhitelisted ? "https://www.stremio.com/warning#".concat(encodeURIComponent(url)) : url;
            if (shell.active) {
                shell.send('open-external', finalUrl);
            }
            else {
                window.open(finalUrl, '_blank');
            }
        }
        catch (e) {
            console.error('Failed to parse external url:', e);
        }
    };
    return (react_1.default.createElement(PlatformContext.Provider, { value: { openExternal: openExternal, name: device_1.name, isMobile: device_1.isMobile } }, children));
};
exports.PlatformProvider = PlatformProvider;
var usePlatform = function () {
    return (0, react_1.useContext)(PlatformContext);
};
exports.usePlatform = usePlatform;
